import React, { ReactNode } from 'react';
import { Trans } from 'react-i18next';
import { UserFixedNotificationsFlow } from '../../../constants/UserFixedNotificationsFlow';
import { EmbeddedNotificationWrapper } from '../EmbeddedNotificationWrapper/EmbeddedNotificationWrapper';
import i18next from 'i18next';
import { EmbeddedNotificationType } from '@signaturit/react-components-library';

export const getEmailReminderNotificationTemplate = (className: string, email?: string): ReactNode => (
    <div className={className}>
        <EmbeddedNotificationWrapper
            title={i18next.t('default._notifications.we_send_and_email_to_update_the_email_title')}
            body={
                <Trans>
                    {i18next.t('default._notifications.we_send_and_email_to_update_the_email', {
                        email,
                    })}
                </Trans>
            }
            type={EmbeddedNotificationType.warning}
            name={UserFixedNotificationsFlow.emailReminder}
        />
    </div>
);
